import _PropTypes from 'prop-types';
import styled from 'styled-components';
import { getDropShadowByElevation } from '../../../styles/elevation.js';
import { getSpacing, getSpacingValue } from '../../../styles/spacing.js';
import { IconDrag } from '../../Icons/IconDrag.js';
import { TREE_LINE_HEIGHT, TREE_DRAG_NODE_Z_INDEX, TREE_DRAG_TYPE } from '../constants.js';
import { dnd } from '../Tree.js';
import { TreeDragHandle } from './TreeDragHandle.js';
import { TreeLabel } from './TreeLabel.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

var StyledDragNodeWrapper = styled.div.withConfig({
  displayName: "TreeDragNode__StyledDragNodeWrapper",
  componentId: "sc-tpxu6l-0"
})({
  position: "relative",
  width: 260
});
var StyledTreeDragNode = styled.div.withConfig({
  displayName: "TreeDragNode__StyledTreeDragNode",
  componentId: "sc-tpxu6l-1"
})(function (_ref) {
  var theme = _ref.theme;
  return {
    backgroundColor: theme.neutralColors.white,
    border: "1px solid ".concat(theme.neutralColors.silver),
    borderRadius: "2px",
    boxShadow: getDropShadowByElevation(1),
    display: "flex",
    lineHeight: TREE_LINE_HEIGHT,
    position: "relative",
    zIndex: TREE_DRAG_NODE_Z_INDEX
  };
});
var StyledTreeDragNodeStacked = styled.div.withConfig({
  displayName: "TreeDragNode__StyledTreeDragNodeStacked",
  componentId: "sc-tpxu6l-2"
})(function (_ref2) {
  var i = _ref2.i,
      theme = _ref2.theme;
  return {
    background: theme.neutralColors.white,
    borderRadius: "2px",
    border: "1px solid ".concat(theme.neutralColors.silver),
    boxShadow: getDropShadowByElevation(1),
    height: getSpacing(8),
    position: "absolute",
    insetBlockStart: 1 + (i + 1) * getSpacingValue(1),
    width: "100%",
    transform: "scaleX(".concat(1 - (i + 1) * 0.05, ")"),
    zIndex: TREE_DRAG_NODE_Z_INDEX - (i + 1)
  };
});

var TreeDragNode = function TreeDragNode(_ref3) {
  var renderLabel = _ref3.renderLabel;

  var _dnd$useDragLayer = dnd.useDragLayer(function (monitor) {
    return {
      currentOffset: monitor.getSourceClientOffset(),
      isDragging: monitor.isDragging(),
      item: monitor.getItem(),
      itemType: monitor.getItemType()
    };
  }),
      currentOffset = _dnd$useDragLayer.currentOffset,
      isDragging = _dnd$useDragLayer.isDragging,
      item = _dnd$useDragLayer.item,
      itemType = _dnd$useDragLayer.itemType;

  if (itemType !== TREE_DRAG_TYPE || !isDragging) {
    return null;
  }

  return /*#__PURE__*/jsx("div", {
    style: {
      position: "fixed",
      pointerEvents: "none",
      zIndex: TREE_DRAG_NODE_Z_INDEX,
      insetInlineStart: 0,
      insetBlockStart: 0,
      width: "100%",
      height: "100%"
    },
    children: /*#__PURE__*/jsxs(StyledDragNodeWrapper, {
      style: {
        transform: "translate(".concat(currentOffset === null || currentOffset === void 0 ? void 0 : currentOffset.x, "px, ").concat(currentOffset === null || currentOffset === void 0 ? void 0 : currentOffset.y, "px)")
      },
      children: [/*#__PURE__*/jsxs(StyledTreeDragNode, {
        children: [/*#__PURE__*/jsx(TreeDragHandle, {
          borderWidth: 1,
          dragging: true,
          children: /*#__PURE__*/jsx(IconDrag, {
            size: 16
          })
        }), /*#__PURE__*/jsx(TreeLabel, {
          children: renderLabel(item)
        })]
      }), item.context.hasChildren() && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(StyledTreeDragNodeStacked, {
          i: 0
        }), /*#__PURE__*/jsx(StyledTreeDragNodeStacked, {
          i: 1
        })]
      })]
    })
  });
};

TreeDragNode.propTypes = {
  "renderLabel": _PropTypes.func.isRequired
};
TreeDragNode.displayName = "TreeDragNode";

export { TreeDragNode };
